import type { AcaoPayload } from "@/hooks/energia/use-melhoria";
import type { RegistoMelhoria } from "../../../lib/energia/melhoria-types";

interface HeaderForm {
  numero: string;
  folha: string;
  tipo_constatacao: string;
  data_constatacao: string;
  origem: string;
  descricao: string;
  identificacao_causas: string;
  prazo_verificacao: string;
  responsavel_verificacao: string;
  responsavel_verificacao_dept_id: string; // "" = none
  metodo_verificacao: string;
  observacoes: string;
  eficaz: string;
  numero_nc: string;
  estado: string;
  gera_risco_oportunidade: string; // "sim" | "nao" | ""
}

export interface AcaoForm {
  tipo_acao: string;
  acao_implementar: string;
  prazo_previsto: string;
  responsavel: string;
  responsavel_dept_id: string; // "" = none
  acao_implementada: string;
  data_implementacao: string;
}

export const EMPTY_HEADER: HeaderForm = {
  numero: "",
  folha: "NC_OM_Reclam",
  tipo_constatacao: "",
  data_constatacao: "",
  origem: "",
  descricao: "",
  identificacao_causas: "",
  prazo_verificacao: "",
  responsavel_verificacao: "",
  responsavel_verificacao_dept_id: "",
  metodo_verificacao: "",
  observacoes: "",
  eficaz: "",
  numero_nc: "",
  estado: "",
  gera_risco_oportunidade: "",
};

export const EMPTY_ACAO: AcaoForm = {
  tipo_acao: "",
  acao_implementar: "",
  prazo_previsto: "",
  responsavel: "",
  responsavel_dept_id: "",
  acao_implementada: "",
  data_implementacao: "",
};

export function toHeaderForm(e: RegistoMelhoria): HeaderForm {
  return {
    numero: e.numero,
    folha: e.folha,
    tipo_constatacao: e.tipo_constatacao,
    data_constatacao: e.data_constatacao ?? "",
    origem: e.origem ?? "",
    descricao: e.descricao ?? "",
    identificacao_causas: e.identificacao_causas ?? "",
    prazo_verificacao: e.prazo_verificacao ?? "",
    responsavel_verificacao: e.responsavel_verificacao ?? "",
    responsavel_verificacao_dept_id: e.responsavel_verificacao_dept_id ?? "",
    metodo_verificacao: e.metodo_verificacao ?? "",
    observacoes: e.observacoes ?? "",
    eficaz: e.eficaz ?? "",
    numero_nc: e.numero_nc ?? "",
    estado: e.estado ?? "",
    gera_risco_oportunidade:
      e.gera_risco_oportunidade === true ? "sim" : e.gera_risco_oportunidade === false ? "nao" : "",
  };
}

export function toAcaoForm(a: RegistoMelhoria["acoes"][number]): AcaoForm {
  return {
    tipo_acao: a.tipo_acao ?? "",
    acao_implementar: a.acao_implementar ?? "",
    prazo_previsto: a.prazo_previsto ?? "",
    responsavel: a.responsavel ?? "",
    responsavel_dept_id: a.responsavel_dept_id ?? "",
    acao_implementada: a.acao_implementada ?? "",
    data_implementacao: a.data_implementacao ?? "",
  };
}

function buildAcaoPayloads(acoes: AcaoForm[]): AcaoPayload[] {
  return acoes
    .filter((a) => a.tipo_acao || a.acao_implementar)
    .map((a, i) => ({
      ordem: i,
      tipo_acao: a.tipo_acao || null,
      acao_implementar: a.acao_implementar.trim() || null,
      prazo_previsto: a.prazo_previsto.trim() || null,
      responsavel: a.responsavel.trim() || null,
      responsavel_dept_id: a.responsavel_dept_id || null,
      acao_implementada: a.acao_implementada.trim() || null,
      data_implementacao: a.data_implementacao || null,
    }));
}

/** O corpo enviado ao servidor: textos aparados, vazios a null, ações sem tipo nem texto descartadas. */
export function buildMelhoriaPayload(header: HeaderForm, acoes: AcaoForm[]) {
  return {
    numero: header.numero.trim(),
    folha: header.folha,
    tipo_constatacao: header.tipo_constatacao,
    data_constatacao: header.data_constatacao || null,
    origem: header.origem.trim() || null,
    descricao: header.descricao.trim() || null,
    identificacao_causas: header.identificacao_causas.trim() || null,
    prazo_verificacao: header.prazo_verificacao.trim() || null,
    responsavel_verificacao: header.responsavel_verificacao.trim() || null,
    responsavel_verificacao_dept_id: header.responsavel_verificacao_dept_id || null,
    metodo_verificacao: header.metodo_verificacao.trim() || null,
    observacoes: header.observacoes.trim() || null,
    eficaz: header.eficaz || null,
    numero_nc: header.numero_nc.trim() || null,
    estado: header.estado || null,
    gera_risco_oportunidade:
      header.gera_risco_oportunidade === "sim" ? true :
      header.gera_risco_oportunidade === "nao" ? false : null,
    acoes: buildAcaoPayloads(acoes),
  };
}

// Estado do formulário (não é um espelho do contrato da API): exportado à parte da declaração.
export type { HeaderForm };
